import {
    GET_LIST_COMMISSION_RULE,
} from '../actions/types';

/**
 * initial state
 */
const INIT_STATE = {
    commission_rules: [],
    pagination: {
        currentPage: 1,
        total: 0, // total records
        perPage: 30
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_LIST_COMMISSION_RULE: {
            return {
                ...state,
                commission_rules: action.payload?.data || [],
                pagination: {
                    currentPage: parseInt(action.payload.current_page),
                    total: parseInt(action.payload.total),
                    perPage: parseInt(action.payload.per_page),
                }
            }
        }
        default: return { ...state };
    }
}
